import ValidationInterface from "@/plans/common/validation-interface";
import {
  basePlanCategories,
  basicPlusCategories,
  SDKCategories,
  SDKUCCategories,
} from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires() {
    return [];
  }

  async conflicts() {
    return this.current(SDKCategories).conflict([
      ...basePlanCategories,
      ...basicPlusCategories,
      ...SDKUCCategories]);
  }
}
